import { render, staticRenderFns } from "./fankuilist.vue?vue&type=template&id=3be2b82c&"
import script from "./fankuilist.vue?vue&type=script&lang=js&"
export * from "./fankuilist.vue?vue&type=script&lang=js&"
import style0 from "./fankuilist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports